import { render, staticRenderFns } from "./ProfileTypeForm.vue?vue&type=template&id=822a9944&scoped=true"
import script from "./ProfileTypeForm.vue?vue&type=script&lang=js"
export * from "./ProfileTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822a9944",
  null
  
)

export default component.exports